import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../Layout/Footer';
import Header from '../Layout/Header';
import feedback from '../../assets/img/notify.jpg';
import { useEffect } from 'react';
import { useState } from 'react';
import { getReviewList } from '../../Redux/Review/action';
import StarRatings from 'react-star-ratings';
import { IMAGE_URL } from '../../api';
import Pagination from '../Pagination';
import InfiniteScroll from 'react-infinite-scroll-component';


const Feedback = () => {
    const [reviews, setReviews] = useState([]);
    const [totalPageNumber, setTotalPageNumber] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    useEffect(() => {
        getReviewList(currentPage, 9)((response) => {
            if (response && response.status) {
                setReviews(response?.data?.data)
                setTotalPageNumber(response?.data?.total_pages)
                if ((reviews.length + response?.data?.data.length) >= response?.data?.count) {
                    setHasMore(false)
                }
                setPage(2)
            }


        });
    }, []);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);

    const paginate = () => {
        getReviewList(page, 9)((response) => {
            if (response.status) {
                if ((reviews.length + response?.data?.data.length) >= response?.data?.count) {
                    setHasMore(false)
                }
                setReviews(reviews.concat(response?.data?.data))
            }
            else {
                setHasMore(false)
            }
        })
        setPage(page + 1)
    }
    return (
        <React.Fragment>
            <Header />
            <section className='pb-0'>
                <div className="breadcrumbs">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 my-auto">
                                <h1>
                                    Feedback </h1>
                                <ul className="trail-items">
                                    <li className="trail-item trail-begin">
                                        <Link to="/">
                                            <span itemProp="name">Home</span><i className="bi bi-chevron-double-right"></i>
                                        </Link>
                                    </li>
                                    <li className="trail-item trail-end">
                                        <span itemProp="item"><span itemProp="name"> Feedback</span></span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section id="team" className="team section-bg">
                <InfiniteScroll
                    dataLength={reviews.length}
                    next={paginate}
                    hasMore={hasMore}
                    loader={<p style={{ textAlign: 'center' }}>
                        <b>Loading...</b>
                    </p>}
                    endMessage={
                        <p style={{ textAlign: 'center' }}>
                            <b>Yay! You have seen it all</b>
                        </p>
                    }
                >
                    <div className="container">
                        <div className="row min-height">
                            {reviews?.map((review, index) =>
                                <div className="col-lg-4">
                                    <div className="member d-flex align-items-start">
                                        {review?.user_list?.image ?
                                            <div className="pic"><img src={IMAGE_URL + review?.user_list?.image} className="img-fluid" alt="" /></div>
                                            :
                                            <div className="pic"><img src={IMAGE_URL + review?.user_details?.image} className="img-fluid" alt="" /></div>
                                        }
                                        <div className="member-info">
                                            <h4>{review?.user_list?.user?.username}</h4>
                                            <span>{review?.category?.name}</span>
                                            <p>{review?.comment}</p>
                                            <div className="stars mt-2">
                                                <StarRatings
                                                    rating={review?.rating}
                                                    starRatedColor="#ffc107"
                                                    // changeRating={this.changeRating}
                                                    numberOfStars={5}
                                                    starDimension="25px"
                                                    starSpacing="2px"
                                                    name='rating'
                                                />
                                            </div>
                                        </div>
                                        <div class="circle"></div>
                                    </div>
                                </div>
                            )}
                            {/* <div className="col-lg-4">
                            <div className="member d-flex align-items-start">
                                <div className="pic"><img src={feedback} className="img-fluid" alt="" /></div>
                                <div className="member-info">
                                    <h4>Sarah Jhonson</h4>
                                    <span>Heal</span>
                                    <p>Aut maiores voluptates amet et quis praesentium qui senda para</p>
                                    <div className="stars mt-2">
                                        <i className="bi bi-star-fill"></i>
                                        <i className="bi bi-star-fill"></i>
                                        <i className="bi bi-star-fill"></i>
                                        <i className="bi bi-star-fill"></i>
                                        <i className="bi bi-star-fill"></i>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-4">
                            <div className="member d-flex align-items-start">
                                <div className="pic"><img src={feedback} className="img-fluid" alt="" /></div>
                                <div className="member-info">
                                    <h4>William Anderson</h4>
                                    <span>Tax</span>
                                    <p>Quisquam facilis cum velit laborum corrupti fuga rerum quia</p>
                                    <div className="stars mt-2">
                                        <i className="bi bi-star-fill"></i>
                                        <i className="bi bi-star-fill"></i>
                                        <i className="bi bi-star-fill"></i>
                                        <i className="bi bi-star-fill"></i>
                                        <i className="bi bi-star-fill"></i>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-4 mt-4">
                            <div className="member d-flex align-items-start">
                                <div className="pic"><img src={feedback} className="img-fluid" alt="" /></div>
                                <div className="member-info">
                                    <h4>Amanda Jepson</h4>
                                    <span>Digital</span>
                                    <p>Dolorum tempora officiis odit laborum officiis et et accusamus</p>
                                    <div className="stars mt-2">
                                        <i className="bi bi-star-fill"></i>
                                        <i className="bi bi-star-fill"></i>
                                        <i className="bi bi-star-fill"></i>
                                        <i className="bi bi-star-fill"></i>
                                        <i className="bi bi-star-fill"></i>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-4 mt-4">
                            <div className="member d-flex align-items-start">
                                <div className="pic"><img src={feedback} className="img-fluid" alt="" /></div>
                                <div className="member-info">
                                    <h4>Walter White</h4>
                                    <span>Astro</span>
                                    <p>Explicabo voluptatem mollitia et repellat qui dolorum quasi</p>
                                    <div className="stars mt-2">
                                        <i className="bi bi-star-fill"></i>
                                        <i className="bi bi-star-fill"></i>
                                        <i className="bi bi-star-fill"></i>
                                        <i className="bi bi-star-fill"></i>
                                        <i className="bi bi-star-fill"></i>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div className="col-lg-4 mt-4">
                            <div className="member d-flex align-items-start">
                                <div className="pic"><img src={feedback} className="img-fluid" alt="" /></div>
                                <div className="member-info">
                                    <h4>Sarah Jhonson</h4>
                                    <span>Heal</span>
                                    <p>Aut maiores voluptates amet et quis praesentium qui senda para</p>
                                    <div className="stars mt-2">
                                        <i className="bi bi-star-fill"></i>
                                        <i className="bi bi-star-fill"></i>
                                        <i className="bi bi-star-fill"></i>
                                        <i className="bi bi-star-fill"></i>
                                        <i className="bi bi-star-fill"></i>
                                    </div>
                                </div>
                            </div>
                        </div> */}

                        </div>
                    </div>
                </InfiniteScroll>
            </section>
            {/* <Pagination setCurrentPage={setCurrentPage} total_pages={totalPageNumber} /> */}

            <Footer />
        </React.Fragment>
    )
}

export default Feedback;